import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { goTo } from '../../shared/utils/angularUtils';
import { coachService } from '../services/coachService';
import { CoachInfoFormValue } from '../interfaces/CoachData';
import { solutionsStore } from '../../shared/stores/solutionsStore';
import { loggedInUserDataStore } from '../../shared/stores/loggedInUserDataStore';
import { EntityBasic } from '../interfaces/EntityBasic';

export const useCoachSetup = () => {
  const [entities, setEntities] = useState<EntityBasic[]>([]);
  const { isEntity, loggedInUser, isSuperAdmin } = loggedInUserDataStore;
  const form = useForm<CoachInfoFormValue>({
    mode: 'onBlur',
  });

  useEffect(() => {
    if (!isSuperAdmin) return;

    const fetchEntities = async () => {
      const res = await coachService.getEntitiesBasics();

      setEntities(res.entities);
    };

    fetchEntities();
  }, [isSuperAdmin]);

  const onSubmit = async (data: CoachInfoFormValue) => {
    const activeSolutionFlags = solutionsStore.activeSolutionFlags;

    if (isEntity && loggedInUser) {
      data.entity = {
        id: loggedInUser.gymId,
        business_name: loggedInUser.gymName,
      };
    }

    await coachService.createCoach(data);

    if (activeSolutionFlags.SCAN_IQ) {
      goTo('/coach-list/scan-iq');
    } else {
      goTo('/coach-list');
    }
  };

  return { form, onSubmit, entities };
};
